/**
 *
 * MultiStepFormHeader
 *
 */
import { Icon } from 'app/components/Icon';
import { ButtonStyled } from 'app/components/ButtonStyled';
import ProgressBarWithSteps from 'app/components/ProgressBarWithSteps';

import {
  StepperWrapper,
  HeaderContainer,
  BackButtonContainer,
  LogoContainer,
  ProgressBarWithStepsContainer,
} from './styles';

interface Props {
  currentStepIndex: number;
  stepsLength: number;
  stepNames: string[];
  isFirstStep: boolean;
  navigateBack: () => void;
}

const MultiStepFormHeader = ({ currentStepIndex, stepsLength, stepNames, isFirstStep, navigateBack }: Props) => {
  return (
    <StepperWrapper>
      <HeaderContainer>
        <BackButtonContainer>
          {!isFirstStep && (
            <ButtonStyled variant="secondary" hasLeftArrow onClick={() => navigateBack()}>
              Back
            </ButtonStyled>
          )}
        </BackButtonContainer>
        <LogoContainer>
          <Icon icon="unmind-full-logo-dark" height={'34px'} width={'149px'} />
        </LogoContainer>
      </HeaderContainer>
      <ProgressBarWithStepsContainer>
        <ProgressBarWithSteps
          color="colors.success.primary"
          width="100%"
          value={currentStepIndex}
          max={stepsLength}
          steps={stepNames}
        />
      </ProgressBarWithStepsContainer>
    </StepperWrapper>
  );
};

export default MultiStepFormHeader;
